export const getApi = async (url) => {
  const response = await fetch(url);
  return await response.json();
};
